<template>
    <div class="table-container members-table">
        <div class="table-wrapper">
            <table ref="edit-board-table" class="table">
                <thead class="table-head">
                    <tr>
                        <th class="table-head__name"></th>
                        <th class="table-head__name">Username</th>

                        <th class="col-width">Admin</th>
                        <th class="col-width">Create<br>Task</th>
                        <th class="col-width">Archive<br>Task</th>
                        <th class="col-width">Edit<br>Task</th>
                        <th class="col-width">Create<br>List</th>
                        <th class="col-width">Archive<br>List</th>
                        <th class="col-width">Edit<br>List</th>
                        <!-- <th class="col-width">Manipulate<br>Tags</th> -->
                        <!-- <th class="col-width">Invite</th> -->
                        <th class="col-width">New Comment</th>
                        <th class="col-width">See Comment</th>
                        <th class="col-width">Upload</th>
                        <th class="col-width">See<br>Expense</th>
                        <th class="col-width">See<br>Billable</th>

                        <th v-if="isAdmin || isOwner || canSeeExpense" style="width: 120px;">Expense</th>
                        <th v-if="isAdmin || isOwner || canSeeBillable" style="width: 120px;">Billable</th>
                        <th style="width: 120px;">
                            <span v-if="isAdmin || isOwner">Remove</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(member, memberIndex) in currentMembers" :key="memberIndex + String(member?.id)">
                        <td>
                            <div class="member-name">
                                <UserAvatar
                                    :user="member.userInfo"
                                    size="large"
                                ></UserAvatar>
                                <!-- <span>{{ member?.userInfo?.name }}</span> -->
                            </div>
                        </td>
                        <td><span class="username">{{ member?.userInfo?.username }}</span></td>
                        <td><Checkbox :disabled="isMemberPermDisabled(member)" @input="value => editMemberPerms(member, value, 'admin')" v-model="member.admin"/></td>
                        <td><Checkbox :disabled="isMemberPermDisabled(member)" @input="value => editMemberPerms(member, value, 'create_task')" v-model="member.create_task"/></td>
                        <td><Checkbox :disabled="isMemberPermDisabled(member)" @input="value => editMemberPerms(member, value, 'archive_task')" v-model="member.archive_task"/></td>
                        <td><Checkbox :disabled="isMemberPermDisabled(member)" @input="value => editMemberPerms(member, value, 'edit_task')" v-model="member.edit_task"/></td>
                        <td><Checkbox :disabled="isMemberPermDisabled(member)" @input="value => editMemberPerms(member, value, 'create_list')" v-model="member.create_list"/></td>
                        <td><Checkbox :disabled="isMemberPermDisabled(member)" @input="value => editMemberPerms(member, value, 'archive_list')" v-model="member.archive_list"/></td>
                        <td><Checkbox :disabled="isMemberPermDisabled(member)" @input="value => editMemberPerms(member, value, 'edit_list')" v-model="member.edit_list"/></td>
                        <!-- <td><Checkbox :disabled="isMemberPermDisabled(member)" @input="value => editMemberPerms(member, value, 'manipulate_tags')" v-model="member.manipulate_tags"/></td> -->
                        <!-- <td><Checkbox :disabled="isMemberPermDisabled(member)" @input="value => editMemberPerms(member, value, 'invite')" v-model="member.invite"/></td> -->
                        <td><Checkbox :disabled="isMemberPermDisabled(member)" @input="value => editMemberPerms(member, value, 'comment')" v-model="member.comment"/></td>
                        <td><Checkbox :disabled="isMemberPermDisabled(member)" @input="value => editMemberPerms(member, value, 'see_comment')" v-model="member.comment"/></td>
                        <td><Checkbox :disabled="isMemberPermDisabled(member)" @input="value => editMemberPerms(member, value, 'upload')" v-model="member.upload"/></td>
                        <td><Checkbox :disabled="isMemberPermDisabled(member)" @input="value => editMemberPerms(member, value, 'see_expense')" v-model="member.see_expense"/></td>
                        <td><Checkbox :disabled="isMemberPermDisabled(member)" @input="value => editMemberPerms(member, value, 'see_billable')" v-model="member.see_billable"/></td>

                        <td v-if="isAdmin || isOwner || canSeeExpense">
                            <div @click.stop="showEditPrice(member, memberIndex, $event, 'userAgentPriceRef')" class="member-price">
                                <button class="show-price" @click="member.isExpenseVisible = !member.isExpenseVisible">
                                    <span class="price-text" v-if="member.isExpenseVisible">
                                        {{ Number(member?.expense) / 100 }}
                                    </span>
                                    <i :class="{'icon-view' : !member.isExpenseVisible}"></i>
                                </button>
                                <img v-if="isAdmin || isOwner" class="edit-icon" src="../assets/images/edit-icon.svg" alt="">
                            </div>
                            <form v-if="isAdmin || isOwner" @click.stop @submit.prevent="updateMemberInfo(member, {expense: userAgentPrice}, memberIndex, 'userAgentPriceRef')" class="editMemberPriceDropContent">
                                <input v-model="userAgentPrice" ref="userAgentPriceRef" placeholder="Expense" />
                                <a href="#" @click.prevent="updateMemberInfo(member, {expense: userAgentPrice}, memberIndex, 'userAgentPriceRef')" class="icon-checkmark"></a>
                                <a href="#" @click.prevent="hideAllPriceEdits" class="icon-close"></a>
                            </form>
                        </td>
                        <td v-if="isAdmin || isOwner || canSeeBillable">
                            <div @click.stop="showEditPrice(member, memberIndex, $event, 'userClientPriceRef')" class="member-price">
                                
                                <button class="show-price" @click="member.isBillableVisible = !member.isBillableVisible">
                                    <span class="price-text" v-if="member.isBillableVisible">
                                        {{ Number(member?.billable) / 100 }}
                                    </span>
                                    <i :class="{'icon-view' : !member.isBillableVisible}"></i>
                                </button>
                                <img v-if="isAdmin || isOwner" class="edit-icon" src="../assets/images/edit-icon.svg" alt="">
                            </div>
                            <form v-if="isAdmin || isOwner" @click.stop @submit.prevent="updateMemberInfo(member, {billable: userClientPrice}, memberIndex, 'userClientPriceRef')" class="editMemberPriceDropContent">
                                <input v-model="userClientPrice" ref="userClientPriceRef" placeholder="Billable" />
                                <a @click.prevent="updateMemberInfo(member, {billable: userClientPrice}, memberIndex, 'userClientPriceRef')" href="#"><i class="icon-checkmark"></i></a>
                                <a @click.prevent="hideAllPriceEdits" href="#"><i class="icon-close"></i></a>
                            </form>
                        </td>
                        <td style="width: 120px;">
                            <button
                                v-if="!isMemberPermDisabled(member) || member.user_id == currentUser.id"
                                @click="$refs['confirm-delete-member'].$refs['confirm-delete-member'].showModal(), memberToDelete = member"
                                class="delete-member"
                            >
                                <img src="../assets/images/delete-icon.svg" alt="" srcset="">
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="btn-wrapper">
            <VButton 
                v-if="isAdmin || isOwner"
                @clickHandler="$refs['new-member'].showModal()"
            >+ Add Member</VButton>
        </div>
        <VModal ref="new-member" size="md" :flexheight="true" class="new-member-modal">
            <form @submit.prevent="">
                <h3>Create Member</h3>
                <label class="bg-description mg-btt-15">Invite New Member (Type User name or Email)</label>

                <div class="relative-container">
                    <div class="dropdown">
                        <input
                            ref="searchMember"
                            v-model="searchMember"
                            type="text"
                            class="text-input"
                            placeholder="Search..."
                            @input="searchUser"
                            @focus="searchUser"
                            @keydown="navUserList"
                        />
                        <div class="users-list" ref="users-list" v-if="apiUsersSearchResult.length > 0">
                            <a
								href="#"
								class="flex-gap-9 dropdown-item"
								v-for="(item, i) in apiUsersSearchResult"
								@click.prevent="addUserToProject(item)"
								:key="item.id"
								@keydown="keyDownHandler($event, i, item)"
							>
                                <UserAvatar
                                    :user="item"
                                    size="medium"
                                ></UserAvatar>
                                <p class="tags-username">
                                    {{ item['username'] }}
                                </p>
                            </a>
                        </div>

                        <div v-else>
                            <p class="tags-username user-dont-exist-msg">User doesn't exist. Click on it to create and invite to the project.</p>
                            <div ref="users-list">
                                <a href="#" @click.prevent="openInviteUserModal" class="dropdown-item flex-gap-9">
                                    {{ this.searchMember }}
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </form>

            <VButton
                @clickHandler="$refs['new-member'].hideModal()"
                class="flow-btn"
            >Back</VButton>
        </VModal>
        
        <VModal title="Invite New Member" ref="invite-user-new-project" class="new-project-flow-modal" size="sm" :flexheight="true">
            <label class="bg-description mg-btt-15">This user is not a Goleko member. Please fill in the fields and press “Invite”.</label>
            <label for="invite-user-name">Name of member</label>
            <Textfield
                id="invite-user-name"
                ref="inviteUserNameRef"
                v-model="currentUserWhoDontExist.name"
                :placeholder="'Name'"
                @keydownenter="inviteUserToNewProject"
                class="new-project-textfield"
            />
            <label for="invite-user-username">Username</label>
            <Textfield
                id="invite-user-username"
                v-model="currentUserWhoDontExist.username"
                @keydown="handleInput"
                @paste="handlePaste"
                @keydownenter="inviteUserToNewProject"
                :placeholder="'Username'"
                class="new-project-textfield"
            />
            <VButton
                @clickHandler="inviteUserToNewProject"
                class="flow-btn"
                active
            >Invite</VButton>
            <VButton
                @clickHandler="cancelUserInvitation"
                class="flow-btn"
                style="margin-left: 10px"
            >Cancel</VButton>
        </VModal>
        <ConfirmDelete
            ref="confirm-delete-member"
            id="confirm-delete-member"
            title="member"
            style="z-index: 300;"
            @delete="deleteMember"
        />
        <Flash ref="show"/>
    </div>
</template>

<script>
import VButton from "@/components/atoms/VButton.vue";
import Textfield from "@/components/atoms/Textfield.vue";
import VModal from "@/components/atoms/VModal.vue";
import ConfirmDelete from "@/components/organism/Confirm.vue";
import Flash from "@/components/Flash.vue";
import UserAvatar from "@/components/atoms/UserAvatar.vue";
import Checkbox from "@/components/atoms/CustomCheckbox.vue";
import {api} from "@/mixins/axios";

export default {
    name: "Members",
    components: {
        VButton,
        Textfield,
        VModal,
        Flash,
        ConfirmDelete,
        UserAvatar,
        Checkbox
    },
    data() {
        return {
            userClientPrice: '',
            userAgentPrice: '',
            currentMembers: null,
            currentUserBoardRole: 'member',
            currentUserInfo: null,
            memberToDelete: null,
            newProjectMembers: [],
            isTagInputFocused: false,
            searchMember: '',
            apiUsersSearchResult: [],
            currentUserWhoDontExist: {
                name: '',
                username: '',
                email: ''
            },
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
        }
    },
    props: ['board_id', 'boardOverviewFunc'],
    computed:{
        boards() {
            return this.$store.getters.boards
        },
        currentUser() {
            return this.$store.getters.currentUser
        },
        members() {
            return this.$store.getters.members
        },
        isAdmin() {
            return this.currentUserBoardRole.includes('admin')
        },
        isOwner() {
            return this.currentUserBoardRole.includes('owner')
        },
        canSeeExpense() {
            return this.currentUserBoardRole.includes('see_expense')
        },
        canSeeBillable() {
            return this.currentUserBoardRole.includes('see_billable')
        }
    },
    mounted() {
        if (this.boards) {
            this.getMembers()
            this.getCurrentUserUpdates()
        }
    },
    watch: {
        boards(value) {
            if (value !== null && this.board_id !== undefined) {
                this.getMembers()
                this.getCurrentUserUpdates()
            }
        },
        board_id(value) {
            if (this.boards !== null && value !== undefined) {
                this.getMembers()
                this.getCurrentUserUpdates()
            }
        }
    },
    methods: {
        async getMembers() {
            if(this.board_id && this.boards) {
                const currentBoard = this.boards.filter(board => board.id == this.board_id)
                try {
                    const data = {project_id: Number(this.board_id)}
                    const response = await api.post("/member_search", data);
                    if (response.data.msg == 'ok') {
                        const allUsers = this.boards.flatMap(board => board.members).filter(user => user)
                        const usersMap = new Map(allUsers.map(user => [user?.id, user]))

                        this.currentMembers = response.data.data.map(member => ({
                            ...member,
                            isExpenseVisible: false,
                            isBillableVisible: false,
                            admin: member.perms.includes('admin') || member.perms.includes('owner'),
                            create_task: member.perms.includes('create_task') || member.perms.includes('admin') || member.perms.includes('owner'),
                            archive_task: member.perms.includes('archive_task') || member.perms.includes('admin') || member.perms.includes('owner'),
                            edit_task: member.perms.includes('edit_task') || member.perms.includes('admin') || member.perms.includes('owner'),
                            create_list: member.perms.includes('create_list') || member.perms.includes('admin') || member.perms.includes('owner'),
                            archive_list: member.perms.includes('archive_list') || member.perms.includes('admin') || member.perms.includes('owner'),
                            edit_list: member.perms.includes('edit_list') || member.perms.includes('admin') || member.perms.includes('owner'),
                            manipulate_tags: member.perms.includes('manipulate_tags') || member.perms.includes('admin') || member.perms.includes('owner'),
                            invite: member.perms.includes('invite') || member.perms.includes('admin') || member.perms.includes('owner'),
                            comment: member.perms.includes('comment') || member.perms.includes('admin') || member.perms.includes('owner'),
                            see_comment: member.perms.includes('see_comment') || member.perms.includes('admin') || member.perms.includes('owner'),
                            upload: member.perms.includes('upload') || member.perms.includes('admin') || member.perms.includes('owner'),
                            see_expense: member.perms.includes('see_expense') || member.perms.includes('admin') || member.perms.includes('owner'),
                            see_billable: member.perms.includes('see_billable') || member.perms.includes('admin') || member.perms.includes('owner'),
                            userInfo: usersMap.get(member.user_id)
                        }));
                    }
                } catch(e) {
                    console.log(e);
                    this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message || 'Something went wrong');
                }

                this.currentUserBoardRole = currentBoard[0]?.yourPerms

                console.log('current Member:', this.currentMembers);
            }
        },
        getCurrentUserUpdates() {
            this.currentUserInfo = this.currentMembers && this.currentMembers.filter(member => member?.id == this.currentUser.id)[0]
        },
        showEditPrice(member, index, event, elRef) {
            this.hideAllPriceEdits()

            this.userAgentPrice = Number(member?.expense) / 100
            this.userClientPrice = Number(member?.billable) / 100

            if (event.target.classList.contains('member-price')) {
                event.target.style.display = 'none'
                event.target.nextElementSibling.style.display = 'flex'
            } else if (event.target.classList.contains('price-text') || event.target.classList.contains('edit-icon')) {
                event.target.parentElement.style.display = 'none'
                event.target.parentElement.nextElementSibling.style.display = 'flex'
            }

            setTimeout(() => {
                if (this.isOwner || this.isAdmin) this.$refs[elRef][index].focus()
            }, 200)
        },
        hideAllPriceEdits() {
            this.$refs['edit-board-table'].querySelectorAll('.editMemberPriceDropContent').forEach(el => el.style.display = 'none')
            this.$refs['edit-board-table'].querySelectorAll('.member-price').forEach(el => el.style.display = 'flex')
        },
        isMemberPermDisabled(member) {
            if (this.isOwner) {
                return member.perms.includes('owner');
            } else if (this.isAdmin) {
                return member.perms.includes('owner') || member.perms.includes('admin');
            } else {
                return true;
            }
        },
        async updateMemberInfo(member, data, index, elRef) {
            if (data.expense && !this.isPriceValid(data.expense)?.valid) {
                this.$refs.show.showFlashError('Only 2 numbers after the dot!');
                this.userAgentPrice = this.isPriceValid(data.expense)?.newVal
                this.$refs[elRef][index].focus()
                return
            }
            if (data.billable && !this.isPriceValid(data.billable)?.valid) {
                this.$refs.show.showFlashError('Only 2 numbers after the dot!');
                this.userClientPrice = this.isPriceValid(data.billable)?.newVal
                this.$refs[elRef][index].focus()
                return
            }

			if(data.expense) {
				data.expense = this.isPriceValid(data.expense)?.newVal
			}
			if(data.billable) {
				data.billable = this.isPriceValid(data.billable)?.newVal
			}
            data.id = member?.id
            try {
                const response = await api.post("/member_edit", data);
                if (response.status === 200) {
                    this.boardOverviewFunc()
                    this.$refs.show.showFlashSuccess("User data updated successfully!");
                    this.hideAllPriceEdits()
                }
            } catch (e) {
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message || 'Something went wrong');
            }
        },
        isPriceValid(price) {
            if (price.includes('.')) {
                const [integerPart, decimalPart] = price.split('.');
                if (decimalPart.length > 2) {
                    return {
                        valid: false,
                        newVal: Math.round(Number(integerPart) / 100)
                    }
                }
            }
			
            return {
                valid: true,
                newVal: Math.round(Number(price) * 100)
            }
        },
        async deleteMember() {
            try {
                const response = await api.post("/member_delete", {id: this.memberToDelete.id});
                if (response.status === 200) {
                    this.$refs.show.showFlashSuccess("User deleted successfully!");
                    this.$refs['confirm-delete-member'].$refs['confirm-delete-member'].hideModal()
                    this.boardOverviewFunc()
                    this.hideAllPriceEdits()

                    if(this.memberToDelete.user_id == this.currentUser.id) {
                        this.$router.push({name: 'boards'})
                    } else {
                        this.memberToDelete = null
                    }
                }
            } catch (e) {
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message || 'Something went wrong');
            }
        },
        editMemberPerms(member, value, perm) {
            if (!this.isOwner && this.isAdmin) {
                value = !value
                this.$refs.show.showFlashError(`You cannot edit owner's permissions`)
                // this.updateMemberInfo(member, {perms: member.perms})
            } else {
                const perms = this.updatePermissions(member.perms, perm, value)
                this.updateMemberInfo(member, {perms}, value)
            }

        },
        updatePermissions(permissionString, permission, addPermission) {
            permissionString = permissionString.replace(/^\|+|\|+$/g, '');

            let permissionsArray = permissionString.split('|');

            const index = permissionsArray.indexOf(permission);

            if (addPermission && index === -1) {
                permissionsArray.push(permission);
            }

            if (!addPermission && index !== -1) {
                permissionsArray.splice(index, 1);
            }

            return '|' + permissionsArray.join('|') + '|';
        },
        isValidEmail(email) {
			if(email) {
				return email.toLowerCase()
				.match(
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
				);
			} else {
				return true
			}
		},
        searchUser() {
            clearTimeout(this.cacheTimer)
            this.cacheTimer = setTimeout(async () => {
                try {
                    const data = {
                        q: this.searchMember,
                        paginate_by: 5
                    }
                    const response = await api.post(`/user_search`, data);
                    if (response.data.msg == 'ok') {
                        this.apiUsersSearchResult = response.data.data.filter(user => user.id !== this.currentUser.id)
                    }

                } catch (e) {
                    this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message)
                }
            }, 500)
        },
        async addUserToProject(item) {
            const data = {
                project: Number(this.board_id),
                user: item.id,
                perms: '|create_task|edit_task|create_list|edit_list|comment|upload|'
            };
            try {
                const response = await api.post("/member_new", data);
                if (response.data.msg === 'ok') {
                    this.searchMember = ''
                    this.searchUser()
                    this.$refs.searchMember.blur()
                    this.boardOverviewFunc()
                    this.$refs.show.showFlashSuccess("User added successfully!");
                    this.$nextTick(() => this.$refs.inviteUserNameRef.$el.querySelector('input').focus())
                    this.getMembers()
                }
            } catch (e) {
                console.log(e);
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message || 'Something went wrong');
                if(e.response?.status === 402) {
                    this.$store.dispatch('updatePlanLimit', 'adding members');
                }
            }
        },
        openInviteUserModal() {
            if (!this.reg.test(this.searchMember)) {
                this.$refs.show.showFlashError("Invalid Email Address");
                return
            }
            
            this.$refs['invite-user-new-project'].showModal()
            this.currentUserWhoDontExist.email = this.searchMember
            this.$nextTick(() => this.$refs.inviteUserNameRef.$el.querySelector('input').focus())
        },
        async inviteUserToNewProject() {
            if (this.currentUserWhoDontExist.name.trim() == '' ||
                this.currentUserWhoDontExist.username.trim() == '' ||
                this.currentUserWhoDontExist.email.trim() == ''
            ) {
                this.$refs.show.showFlashError("Empty field");
                return
            }

            if (!this.reg.test(this.currentUserWhoDontExist.email)) {
                this.$refs.show.showFlashError("Invalid Email Address");
                return
            }

            try {
                const response = await api.post('/user_invite', this.currentUserWhoDontExist)
                if (response.data.msg == 'ok') {
                    this.addUserToProject(response.data.data)
                    this.cancelUserInvitation()
                }
            } catch(e) {
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message || `Couldn't invite user`)
            }
        },
        cancelUserInvitation() {
            this.currentUserWhoDontExist = {
                name: '',
                username: '',
                email: ''
            }
            this.$refs['invite-user-new-project'].hideModal()
        },
        handleInput(_, event) {
            if (event.key == ' ') event.preventDefault()
        },
        handlePaste(event) {
            setTimeout(() => this.currentUserWhoDontExist.username = event.target.value.replace(/\s/g, ''), 10)
        },
        keyDownHandler(e, i, item) {
            console.log(e)
            console.log(i)
            let index = 0;
            if((e.key === 'ArrowDown' || e.key == 'Tab') && i != this.$refs['users-list'].children.length-1) {
                index = i+1
                this.$refs['users-list'].children[index]?.focus()
            } else if(e.key === 'ArrowUp' && i != 0) {
                index = i-1
                this.$refs['users-list'].children[index]?.focus()
            } else if(e.key === 'ArrowUp' && i == 0) {
                index = this.$refs['users-list'].children.length-1
                this.$refs['users-list'].children[index]?.focus()
            }
		},
        navUserList(e) {
            console.log(e)
            if(e.key === 'Enter' && this.apiUsersSearchResult[0]) {
                this.addUserToProject(this.apiUsersSearchResult[0])
            } else if(e.key === 'ArrowDown') {
                this.$refs['users-list'].children[0]?.focus()
            }
        },
    }
}
</script>

<style lang="scss">
.members-table {
    .table {
        table-layout: fixed;
    }

    .modal {
        overflow: visible;
    }

    .btn-wrapper {
        padding: 15px;
    }
}
.table-container {
    margin: 15px;
    background: var(--primary-bg);
    border-radius: 10px;
    height: calc(100vh - 70px);

    .table-wrapper {
        max-height: 100%;
        overflow-y: auto;
    }

    .table {
        width: 100%;
    }

    .table-head {
        border-bottom: 1px solid #4D4D4D;

        &__name {
            width: 200px;
        }

        th {
            padding: 18px 0 12px;
            &:first-of-type {
                padding-left: 24px;
            }

            &:last-of-type {
                padding-right: 24px;
            }
        }
        .col-width {
            width: 70px;
            padding-right: 5px;
        }
    }

    .username {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .table-head th {
        font-size: 16px;
        font-weight: 500;
        line-height: 20.16px;
    }

    th,
    td {
        &:first-of-type {
            width: 60px;
        }
    }

    tbody {
        td {
            padding: 13px 0 10px;
            &:first-of-type {
                padding-left: 24px;
            }
            &:last-of-type {
                padding-right: 24px;
            }
        }

        tr:nth-child(even) {
            background: #7373732E;
        }
        .member {
            color: $blue-text;
        }
    }

    .btn.dark {
        width: fit-content !important;
        background: #7373732E;
        color: $blue-text;
        margin-left: 15px;
        margin-top: 15px;
        border-radius: 6px;
        height: 30px;
    }
}

.editMemberPriceDropContent {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    display: none;
    input {
        border-radius: 8px;
        width: 100%;
        padding: 5px 10px;
        background-color: #f9fafb;
        border: 1px solid #d1d5db;
        color: #111827;
        width: 70px;
    }
}
.delete-member { cursor: pointer; }
.member-price {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 20px;
    cursor: pointer;
}

.member-name {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-right: 20px;
    width: max-content;
}

.delete-member {
    color: #fff;
    border: none;
}

.show-price {
    cursor: pointer;
    font-size: 16px;
    border: none;
    color: $gray-1;
}

.new-member-modal .input-tags-wrap {
    height: 60px;
}

.new-member-modal .modal {
    height: 470px;
}

.new-member-modal {

    .relative-container {
        height: fit-content;
        margin-bottom: 15px;
    }

    .dropdown {
        position: relative;

        .new-user {
            background: rgba(158, 158, 158, 0.2);
        }
    }
    
}
</style>